import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { urlReplace } from 'shared/modules';
import newsImg from 'shared/assets/images/newspaper.svg';
import s from './VideosItem.css';
import withPixelRatio from '../../hocs/withPixelRatio';

export const TYPES = {
  TABLE: 'table',
  LIST: 'list',
};

export const itemPropType = {
  handleShowVideo: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string,
    title: PropTypes.string,
    caption: PropTypes.string,
  }).isRequired,
  imgHeight: PropTypes.number,
  imgWidth: PropTypes.number,
  type: PropTypes.string,
};

class VideosItem extends React.Component {
  static propTypes = {
    ...itemPropType,
    setRatioImage: PropTypes.func.isRequired,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    imgHeight: 200,
    imgWidth: null,
    type: TYPES.TABLE,
  };

  render() {
    const {
      index,
      title,
      title_uk: titleUk,
      slug,
      image,
      imgHeight,
      type,
      setRatioImage,
      imgWidth,
      handleShowVideo,
      intl,
    } = this.props;
    //
    const isList = type === TYPES.LIST;
    const hasImage = !!image.url;
    const imageSrc = image && setRatioImage(image.url, 240, 200, 'contain');
    const isMobile = __APP__ === 'mobile';
    const { locale } = intl;
    const localizedTitle = locale === 'ru' ? title || titleUk : titleUk || title;

    return (
      <div
        className={cx(s.root, [isMobile && s.mobileRoot])}
        onClick={() => handleShowVideo({ id: slug, index })}
      >
        <div
          className={cx({
            [s.listThumb]: isList,
            [s.tableThumb]: !isList,
            [s.placeholderThumb]: !hasImage,
          })}
          style={
            imgHeight
              ? {
                  backgroundImage: `url(${urlReplace(imageSrc || newsImg)})`,
                  height: imgHeight,
                  [imgWidth && 'width']: imgWidth && imgWidth,
                }
              : {}
          }
        >
          <span className={s.tableDate}>{localizedTitle}</span>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(withPixelRatio(VideosItem)));



// WEBPACK FOOTER //
// ./src/shared/components/VideosItem/VideosItem.js